module.exports = __webpack_public_path__ + "static/media/pexels-photo-1.47cf508b.png";